import { TrackGroupTypeBox } from '#//box';

export class msrcTrackGroupTypeBox extends TrackGroupTypeBox {
  static override readonly fourcc = 'msrc' as const;
}
